import { createApp } from "vue";
import App from "./App.vue";
import { ensureSchema } from "./db/init";
import { useSupabase } from "./db/supabaseClient.js";
import router from './router/index.js';

(async () => {
  // Clear cache in development mode
  if (import.meta.env.DEV) {
    try {
      // Clear all caches
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map(name => caches.delete(name)));
        console.log('✓ Browser caches cleared');
      }
      
      // Clear localStorage version to force refresh
      const currentVersion = Date.now().toString();
      const lastVersion = localStorage.getItem('app_version');
      if (lastVersion !== currentVersion) {
        localStorage.setItem('app_version', currentVersion);
        console.log('✓ App version updated');
      }
    } catch (e) {
      console.warn('Cache clearing failed:', e);
    }
    try {
      if ('serviceWorker' in navigator) {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map((r) => r.unregister()));
      }
    } catch {}
  }

  if (!useSupabase()) {
    try { await ensureSchema(); } catch {}
  }
  createApp(App).use(router).mount("#app");
  if (!import.meta.env.DEV && 'serviceWorker' in navigator && !(typeof window !== 'undefined' && window.__TAURI__)) {
    try {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js').catch(() => {});
      });
    } catch {}
  }
})();
